var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainIconBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Storm, rain, cloud"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9787 39.2559C94.9551 41.0164 95.4402 42.0534 97.0115 40.5269C98.8776 38.0849 99.3803 35.2559 99.215 32.2634C97.6075 30.4033 94.4973 37.6881 94.9787 39.2559ZM74.7122 25.37C74.4695 21.3334 73.5465 16.9341 69.8789 14.5236C69.5429 14.258 69.1396 14.1693 68.8333 14.4868C64.2149 18.6813 63.8897 26.5953 67.7894 31.3591C68.9821 32.7345 70.4805 32.6927 72.0437 32.2878C75.1691 31.462 74.3462 27.9472 74.7122 25.37ZM34.2962 32.0263C33.9933 39.3339 40.1583 45.8988 47.609 43.4244C53.0296 40.5644 47.4917 30.2064 42.9568 28.4139C37.0415 26.3619 34.4966 23.8871 34.2962 32.0263ZM66.3937 12.2495C58.6486 7.18045 47.169 7.09881 40.5588 13.5663C39.5483 15.3228 34.9226 22.0725 37.2254 23.3092C41.2273 24.3825 45.4923 25.3028 48.3387 28.5798C57.0574 38.8083 51.7912 51.22 37.9678 45.2522C32.949 42.8048 30.7799 37.5078 30.8794 32.1543C30.3799 30.5736 32.2798 27.3117 30.4262 26.6442C21.6349 26.4531 14.9988 33.0867 11.1637 40.424C8.9919 44.7036 10.0316 49.7327 9.95589 54.3512C10.2845 56.8632 10.4765 62.3467 13.8631 62.2218C27.1157 61.6969 40.4215 61.6858 53.6873 61.2055C66.7134 60.3456 79.7909 60.9839 92.812 60.0626C95.5782 60.2939 109.5 58.0679 109.942 60.0284C110.038 61.9671 111.984 61.7368 113.389 61.7124C116.399 61.2657 120.263 62.3407 122.855 60.9663C123.143 58.2914 125.637 56.4415 125.411 53.6438C125.023 45.2794 120.881 37.1209 114.722 31.517C112.923 29.3623 103.401 26.6925 102.866 30.7318C102.433 33.8321 102.828 37.1987 101.13 39.9779C97.897 45.4357 91.1279 47.0593 92.3395 38.5776C94.324 26.2762 103.811 32.8205 98.3396 14.7071C94.472 8.54957 85.3912 2.88451 78.301 7.06287C76.3112 8.27166 74.5426 9.7624 72.6552 11.0986C71.5269 11.9601 73.4171 12.8685 73.9105 13.5457C79.5281 19.0173 80.9632 35.4413 70.3021 35.5653C60.0403 34.0141 60.336 18.3692 66.3937 12.2495ZM64.3737 66.0338C54.2642 66.1112 44.1573 65.9486 34.05 65.7742C28.3348 65.7115 22.6182 65.7362 16.9123 65.3037C14.5378 65.1138 11.9304 66.2684 10.2063 64.0643C4.9338 57.7454 4.32671 42.807 9.64065 36.3894C13.55 30.7448 18.7062 24.9732 25.8524 23.886C27.9704 23.1167 31.6823 23.9911 32.784 21.7255C33.8349 18.5758 35.0648 15.4732 36.9911 12.7417C42.8919 4.36738 55.4599 3.21281 64.3271 7.1441C66.1856 7.57828 67.8689 9.50576 69.7291 9.26634C74.7803 5.6423 79.8434 0.601735 86.6062 2.33125C98.1689 6.08095 104.061 13.2901 103.302 25.6791C105.037 27.6629 111.416 24.222 116.028 28.5587C123.045 34.0399 127.189 42.3736 129.007 50.9383C130.533 55.4501 127.096 58.7031 127.161 62.5267C127.689 64.2461 126.186 65.2159 124.575 64.9195C120.713 64.7496 116.855 64.6926 113.006 65.144C96.7996 65.5812 80.5799 65.5114 64.373 65.9698C64.3732 65.9911 64.3735 66.0126 64.3737 66.0338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5668 80.1577C68.7708 79.169 68.9862 77.9575 69.2748 76.764C69.7856 73.8722 75.0792 69.2412 75.2084 74.694C74.8702 78.5726 68.7183 91.0537 68.5668 80.1577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2761 79.1191C19.5871 76.5038 19.8753 70.311 22.2425 69.5967C23.3472 70.2519 25.2554 70.237 25.0475 72.0475C24.654 75.1329 20.7658 89.4299 19.2761 79.1191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5177 82.4117C94.8178 79.665 96.4023 70.5877 100.203 73.8949C103.529 76.193 97.8165 81.932 96.9359 84.7728C95.5858 87.319 94.0904 83.7472 94.5177 82.4117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7647 91.8529C83.7559 95.2726 82.7443 98.4956 81.7162 102.18C78.5566 104.718 78.9583 94.6434 80.5521 93.2996C81.7002 91.6084 84.072 89.9301 85.7647 91.8529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.215 95.2444C54.1538 93.6575 55.1652 90.0224 57.7377 90.3958C62.6148 92.0941 57.35 98.2941 55.6492 100.859C53.6945 102.381 54.6021 96.8497 54.215 95.2444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8863 82.2174C43.2505 79.7628 47.4825 69.6804 50.2558 74.6825C49.8375 76.5478 43.8452 90.0925 43.8863 82.2174Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2556 111.503C93.3038 113.269 89.8271 121.144 87.9289 119.448C88.7564 116.693 88.1884 109.64 91.6154 109.115C92.8679 109.299 93.3727 110.237 93.2556 111.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3102 97.3584C28.0498 95.0601 33.027 88.0274 33.5306 93.0893C34.8417 95.6021 31.6524 98.0592 30.0086 99.6423C28.6346 100.644 28.6003 98.0973 28.3102 97.3584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2008 116.615C61.5669 112.528 67.1578 108.12 67.373 113.809C66.0544 116.164 62.9915 123.258 62.2008 116.615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1244 132.002C67.1068 128.518 71.6098 124.095 72.54 127.143C72.0868 128.715 73.6675 129.191 73.1954 130.489C72.458 131.591 67.8948 135.043 67.9588 132.009L68.1244 132.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.284 99.6298C103.743 97.1793 107.503 91.5191 109.512 94.733C110.643 96.5778 103.97 104.707 104.38 99.6339C104.348 99.6326 104.316 99.6311 104.284 99.6298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9619 111.974C42.1046 110.731 42.0927 108.328 44.0734 108.544C45.0065 108.569 45.7643 109.16 45.8062 110.054C45.8753 114.212 42.0151 120.298 41.9619 111.974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2222 128.015C60.1712 128.403 55.6123 133.614 54.0621 134.019C51.4441 133.134 53.7966 127.628 56.2222 128.015Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainIconBl);
export default __webpack_public_path__ + "static/media/rain-icon-bl.5a3cc8ae448b6561d7e098525b2fe67e.svg";
export { ForwardRef as ReactComponent };